<script lang="ts">
    import { fade } from 'svelte/transition';
    import { createEventDispatcher } from 'svelte';
    import { Howler } from 'howler';
    import Toggle from 'svelte-switcher';
    import { MODAL_TABS } from '@src/constants/index';
    import TitleMenu from './components/title-menu.svelte';
    import GameRules from './main-menu-rules.svelte';
    import IconLevelVolume from '../../icons/icon-level-volume.svelte';
    import RangeSlider from '../range-slider/range-slider.svelte';
    import { trackEvent } from '@root/src/utils/init-analytics.js';

    // TODO: rewrite. keep dumb component ?
    const dispatch = createEventDispatcher();

    export let currentTab;
    export let musicEnabled;
    export let soundEnabled;

    let listItemClasses = 'text-md flex justify-between py-4 text-white items-center';
    let volumeLevel = Howler.volume();

    const handleChangeVolume = event => {
        volumeLevel = event.target.value;

        trackEvent('sound_change', {
            volume_new_state: event.target.value,
            change_origin: 'system_menu'
        });
    };
    const handleVolumeIcon = () => {
        const newVolumeLevel = Number(!volumeLevel);

        volumeLevel = newVolumeLevel;

        trackEvent('sound_change', {
            volume_new_state: newVolumeLevel,
            change_origin: 'system_menu'
        });
    };

    const changeMusicSetting = e => {
        dispatch('musicChange', e.detail);
        trackEvent('sound_change', {
            music_new_state: e.detail ? 'on' : 'off',
            change_origin: 'system_menu'
        });
    };

    const changeSoundSetting = e => {
        dispatch('soundChange', e.detail);
        trackEvent('sound_change', {
            sound_new_state: e.detail ? 'on' : 'off',
            change_origin: 'system_menu'
        });
    };

    $: Howler.volume(volumeLevel);
</script>

<div class="mx-auto w-full max-w-2xl">
    {#if currentTab === MODAL_TABS.SETTINGS}
        <div class="settings font-Roboto" in:fade|global>

            <TitleMenu class="!mb-4 text-center !text-2xl tablet:!text-4xl">Audio</TitleMenu>
            <ul class="menu desktop:divide-y desktop:divide-solid desktop:divide-white/10">
                <li class={listItemClasses}>
                    <span>Volume</span>
                    <div class="inline-flex w-full max-w-[200px] items-center gap-4">
                        <RangeSlider bind:value={volumeLevel} on:input={handleChangeVolume} class="ml-6 !w-full" />
                        <span class="h-10 w-10">
                            <IconLevelVolume {volumeLevel} muted={volumeLevel === 0} on:click={handleVolumeIcon} />
                        </span>
                    </div>
                </li>

                <li class={listItemClasses}>
                    <span>Music</span>
                    <Toggle name="music" checked={musicEnabled} on:toggle={changeMusicSetting} />
                </li>

                <li class={listItemClasses}>
                    <span>Sound effects</span>
                    <Toggle name="sound" checked={soundEnabled} on:toggle={changeSoundSetting} />
                </li>
            </ul>
        </div>
    {:else if currentTab === MODAL_TABS.INFO}
        <div class="info" in:fade|global>
            <GameRules />
        </div>
    {/if}
</div>
